export const shareImage = async (
  generatedImage: Blob,
  name: string,
): Promise<void> => {
  const file = new File([generatedImage], `merci${name}.png`);

  try {
    if (navigator.share !== undefined) {
      await navigator.share({
        files: [file],
      });
      return;
    }
  } catch (e) {
    virtualDownload(generatedImage, name);
  }
};

const virtualDownload = (generatedImage: Blob, name: string) => {
  const imageObjectURL = window.URL.createObjectURL(generatedImage);
  const link = document.createElement("a");
  link.href = imageObjectURL;
  link.setAttribute("download", `merci${name}.png`);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(link.href);
};
